angular.module('dnecom')
    .factory('notifications', ['$q', function ($q) {
        var showNotification = function (options) {
            var defOptions = {
                style: 'flip',
                position: 'top-right',
                timeout: 4000
            };
            options = $.extend(defOptions, options);
            $('body').pgNotification(options).show();
        };

        return {
            success: function (message) {
                showNotification({
                    message: message,
                    type: 'success'
                });
            },
            info: function (message) {
                showNotification({
                    message: message,
                    type: 'info'
                });
            },
            warning: function (message) {
                showNotification({
                    message: message,
                    type: 'warning'
                });
            },
            danger: function (message) {
                showNotification({
                    message: message,
                    type: 'danger'
                });
            },
            fromResponse: function(response) {
                var data = response.data;
                return $q(function(resolve, reject) {
                    if (typeof data === 'string') {
                        resolve([response.status, response.statusText]);
                    } else if ('detail' in data && 'title' in data) {
                        resolve([data.detail, data.title]);
                    } else if ('hydra:description' in data && 'hydra:title' in data) {
                        resolve([data['hydra:description'], data['hydra:title']]);
                    } else if ('message' in data) {
                        resolve([data.message, undefined]);
                    } else {
                        resolve(['Unknown error', undefined]);
                    }
                }).then(function(res) {
                    showNotification({
                        message: res[0]+ ': ' + res[1],
                        type: 'danger'
                    });
                });
            }
        };
    }]);